import SnackbarUtils from '../utils/SnackbarUtils';
export interface EnvironmentType {
  environment: 'default' | 'develop' | 'homolog' | 'preprod' | 'production';
  isOffline: boolean;
  apis: {
    backofficeProjetos: string;
    bff: string;
    assessoria: string;
    contrato: string;
  };
  links: {
    changePassword: string;
    forgotPasswordEmail: string;
    forgotPasswordPSMS: string;
  };
  auth: {
    authUrl: string;
    logoutUrl: string;
    clientID: string;
    redirectUrl: string;
    logofRedirectUrl: string;
    PE_WEB_URL: {
      home: string;
      gestao_cadastro: string;
      registro_pedagogico: string;
      contratos: string;
    }
  };
  analytics?: {
    gtmContainerId: string;
    enableConsentMode: boolean;
  }
}

let loadedEnvironment: EnvironmentType | null = null;

export const loadEnvironments = (callbackSuccess: (env: EnvironmentType) => void) => {
  if (loadedEnvironment) {
    callbackSuccess(loadedEnvironment);
    return;
  }

  if (window.env) {
    loadedEnvironment = window.env as EnvironmentType;
    callbackSuccess(loadedEnvironment);
  } else {
    SnackbarUtils.enqueueSnackbar({
      message: 'window.env não está definido!',
      options: {
        variant: 'error',
      },
    });
  }
};

export const getApis = () => {
  if (!loadedEnvironment) {
    throw new Error('Variáveis de ambiente não carregadas!');
  }
  return loadedEnvironment;
};
